<template>
  <div>
    <div class="container">
      <h1 class="page-title text-center mt-5">Xilda Class</h1>
      <h2 class="sub-title text-center mb-4 mb-md-5">รวมวิดีโอเทคนิคการตัดผมทั้งหมด</h2>

      <div v-if="!isVideosLoaded">
        <div class="row mb-3 align-items-end" v-for="index in 3" :key="index">
          <div class="col-12 col-md-7 placeholder">
            <div class="blog-article">
              <div class="thumbnail mb-3"></div>
            </div>
          </div>
          <div class="col-12 col-md-5 placeholder">
            <div class="blog-article">
              <div class="paragraph mb-4" style="width: 30%;"></div>
              <div class="paragraph mb-2" style="width: 100%;"></div>
              <div class="paragraph mb-2" style="width: 70%;"></div>
              <div class="paragraph mb-2" style="width: 90%;"></div>
              <div class="paragraph mt-4" style="width: 80%;"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="blog-article" v-for="(video, key) in videos" :key="key">
          <div class="row mb-3 align-items-end">
            <div class="col-12 col-md-7">
              <div class="thumbnail">
                <div class="thumbnail-media" v-lazy-container="{ selector: 'img' }" v-if="video._embedded">
                  <img :data-src="`${video._embedded['wp:featuredmedia'][0].media_details.sizes['post-thumbnail'].source_url}`" :data-srcset="`${video._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url} 2x`" class="d-block m-auto" />
                </div>
                <!-- /.thumbnail-media -->
                <div class="article-duration" v-html="video.acf.video_duration"></div>
              </div>
              <!-- /.thumbnail -->
            </div>
            <div class="col-12 col-md-5">
              <div class="blog-desc">
                <div class="category" v-html="$t('message.video')"></div>
                <div class="description" v-html="video.title.rendered"></div>
                <p class="" v-html="video.acf.author"></p>
                <p class="event-schedule d-none d-md-block" v-html="dateFormat(video.date)"></p>
              </div>
            </div>
          </div>
          <router-link :to="{ name: video.type, params: { slug: video.slug } }" class="item-link"></router-link>
        </div>

        <div class="row my-5" v-if="totalpages > 1">
          <div class="col text-center">
            <button type="button" :class="['btn', currentpage === index ? 'dark' : 'light', 'mr-3', 'pagination', isButtonLoading ? 'disabled': '']" :disabled="isButtonLoading" @click="getClass(index)" v-for="(index) in totalpages" :key="index">{{ index }}</button>
          </div>
        </div>
        <!-- /.row -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import dayjs from 'dayjs'
import 'dayjs/locale/th'
export default {
  name: 'XildaClass',
  data () {
    return {
      api_path: process.env.VUE_APP_API_PATH,
      title: process.env.VUE_APP_TITLE,
      isVideosLoaded: false,
      videos: [],
      page: null,
      per_page: 12,
      currentpage: this.$route.query.paged || 1,
      totalpages: 0,
      isButtonLoading: true
    }
  },
  mounted () {
    document.title = `Xilda Class - ${this.title}`
    this.getClass(this.currentpage)
  },
  methods: {
    getClass (page = 1) {
      const lang = this.$route.params.lang
      const $vm = this
      $vm.isButtonLoading = true
      $vm.isVideoLoaded = false
      axios.get(`${this.api_path}wp-json/wp/v2/video`, {
        params: {
          _embed: true,
          per_page: $vm.per_page,
          page,
          lang
        }
      })
        .then(res => {
          if (res.data) {
            $vm.totalpages = parseInt(res.headers['x-wp-totalpages'])
            $vm.videos = res.data
            $vm.isVideosLoaded = true
            $vm.$router.push({ query: { paged: page } })
            $vm.currentpage = parseInt(page)
            $vm.page = page + 1
            $vm.isButtonLoading = false
          }
        })
    },
    dateFormat (date, format = 'D MMMM YYYY') {
      const lang = this.$route.params.lang
      return dayjs(date).locale(lang).format(format)
    }
  }
}
</script>
